import type { NextPageWithLayout } from "@interfaces/PageInterfaces";
import { womenCategoryPage } from "@lib/constants/pagePaths";
import { getProductListLayout } from "@lib/utils/layoutUtility";
import type { GetStaticPropsContext, PreviewData } from "next";
import type { ParsedUrlQuery } from "querystring";
import {
    generateGetStaticPropsForProductListingPage,
    generateProductListingPageStaticPaths,
    ProductListingPage,
    type ProductListingPageProps,
} from "templates/ProductListingPage";

const WomenProductListingPage: NextPageWithLayout<ProductListingPageProps> = (props) => {
    return (
        <>
            <div hidden aria-hidden="true" data-testid="womenCategories" />
            <ProductListingPage {...props} isMenPage={false} />
        </>
    );
};

export default WomenProductListingPage;

WomenProductListingPage.getLayout = getProductListLayout;

export const getStaticProps = async (
    context: GetStaticPropsContext<ParsedUrlQuery, PreviewData>
) => {
    return await generateGetStaticPropsForProductListingPage(context, womenCategoryPage);
};

export const getStaticPaths = async () => {
    return await generateProductListingPageStaticPaths();
};
